import { useEffect, useState } from 'react'

export const SCHEDULED_MAINTENANCE_ID = 'scheduled-maintenance-2026-09-02'
export const SCHEDULED_MAINTENANCE_START = '2026-09-02T16:00:00+02:00'
export const SCHEDULED_MAINTENANCE_END = '2026-09-02T18:00:00+02:00'

const maintenanceEndTimestamp = new Date(SCHEDULED_MAINTENANCE_END).getTime()

export const isScheduledMaintenanceActive = (now = Date.now()) => now < maintenanceEndTimestamp

export const useScheduledMaintenance = () => {
  const [isActive, setIsActive] = useState(() => isScheduledMaintenanceActive())

  useEffect(() => {
    const millisecondsUntilEnd = maintenanceEndTimestamp - Date.now()

    if (millisecondsUntilEnd <= 0) {
      setIsActive(false)
      return undefined
    }

    // The explicit Italian time-zone offset keeps the expiry fixed at 18:00 in Italy for every user.
    const expirationTimeout = window.setTimeout(() => setIsActive(false), millisecondsUntilEnd)

    return () => window.clearTimeout(expirationTimeout)
  }, [])

  return isActive
}
